// removed by extract-text-webpack-plugin
module.exports = {"button":"_2lEqW","page":"H_0k-","heading":"_1pPye","playlist":"_2RV8x","name":"jvg5P","description":"_1GPo-","cover":"RmSWx","fixedLists":"_3GaPK"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Playlists.css
// module id = 861
// module chunks = 0